import { useCallback, useMemo, useState } from 'react'

import { AvailabilitySidePanelActionsContext, AvailabilitySidePanelStateContext } from './context'

const FORMATS = ['calendar', 'list']

export const AvailabilitySidePanelProvider = ({ children }) => {
  const [availabilitySidePanelProps, setAvailabilitySidePanelProps] = useState({})

  const isAvailabilitySidePanelOpen = Boolean(availabilitySidePanelProps.formPath && availabilitySidePanelProps.format)

  const openAvailabilitySidePanel = useCallback(({ formPath, format, targetRef }) => {
    if (FORMATS.includes(format)) {
      setAvailabilitySidePanelProps({ formPath, format, targetRef })
    }
  }, [setAvailabilitySidePanelProps])

  const closeAvailabilitySidePanel = useCallback(() => (
    setAvailabilitySidePanelProps({})
  ), [setAvailabilitySidePanelProps])

  const toggleAvailabilitySidePanel = useCallback(({ formPath, format, targetRef, checkFormat = true }) => {
    setAvailabilitySidePanelProps((prev) => {
      const sameSidePanelOpened = prev.format && prev.formPath && prev.formPath === formPath
      const shouldCloseSidePanel = sameSidePanelOpened && (!checkFormat || prev.format === format)

      if (shouldCloseSidePanel || !FORMATS.includes(format)) {
        return {}
      }

      return { formPath, format, targetRef }
    })
  }, [])

  const state = useMemo(() => ({
    availabilitySidePanelProps,
    isAvailabilitySidePanelOpen,
  }), [
    availabilitySidePanelProps,
    isAvailabilitySidePanelOpen
  ])

  const actions = useMemo(() => ({
    openAvailabilitySidePanel,
    closeAvailabilitySidePanel,
    toggleAvailabilitySidePanel
  }), [
    openAvailabilitySidePanel,
    closeAvailabilitySidePanel,
    toggleAvailabilitySidePanel
  ])

  return (
    <AvailabilitySidePanelStateContext.Provider value={state}>
      <AvailabilitySidePanelActionsContext.Provider value={actions}>
        {children}
      </AvailabilitySidePanelActionsContext.Provider>
    </AvailabilitySidePanelStateContext.Provider>
  )
}
